import { Component, Inject, Input, NgZone, OnInit, OnChanges, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { take } from 'rxjs/operators';
import { GridComponent, GridDataResult, DataStateChangeEvent } from '@progress/kendo-angular-grid';
import { process, State, CompositeFilterDescriptor, orderBy } from '@progress/kendo-data-query';
import { CRMService } from '../../services/crm.service';
import { EmployeeService } from '../../services/employees.service';
import { NotificationService } from '../../services/notification.service';
import { OrderService } from '../../services/order.service';
import { RecordLockService } from '../../services/recordlock.service';
import { UtilService } from '../../services/util.service';
import {
    City,
    Customer,
    CustomerInitiative,
    CustomerLookup,
    CustomerStatus,
    CustomerTeamType,
    Employee,
    RecordType,
    SearchCustomer,
    SearchCustomerCriteria,
    SearchRecordLock,
    SearchTagType
} from '../../models/models';

@Component({
    selector: 'customer-list',
    templateUrl: './customer-list.component.html',
    standalone: false
})

export class CustomerList implements OnInit, OnChanges {
    @Input() pageType: string = "Accounts";
    @Input() repType: string = "";
    @Input() employeeID: number = 0;
    @Input() filter: number = 0;

    @ViewChild(GridComponent, { static: false }) public customerListGrid!: GridComponent;

    public pageTitle: string = "Accounts";
    public customersBase: SearchCustomer[] = [];
    public customers: SearchCustomer[] = [];
    public employeeList: Employee[] = [];
    public salesReps: Employee[] = [];
    public opsReps: Employee[] = [];
    public fromEmployeeList: Employee[] = [];
    public toEmployeeList: Employee[] = [];
    public accountReps: Employee[] = [];
    public initiatives: CustomerInitiative[] = [];
    public customerStatusList: CustomerStatus[] = [];
    //public parentCustomers: Customer[] = [];
    public gridData: GridDataResult = { data: [], total: 0 };
    public gridState: State = {
        skip: 0,
        take: 10,
        sort: [{ dir: 'asc', field: 'customerName'}],
        filter: {
            filters: [
                { field: 'activeInd', value: true, operator: 'eq' },
                { field: 'retiredInd', value: false, operator: 'eq' }
            ],
            logic: 'and'
        } as CompositeFilterDescriptor
    };
    public pageSizes: number[] = [5, 10, 20, 50, 100, 200, 500];

    //private editedCustomerRowIndex: number | undefined;
    //private editedCustomer: Customer = {} as Customer;
    public searchCustomer: SearchCustomer = {} as SearchCustomer;
    private customerID: number = 0;
    //private parentCustomer: Customer = {} as Customer;
    private parentCustomerID: number = 0;
    public customerIsValid: boolean = true;
    public isAdd: boolean = false;
    public isEdit: boolean = false;
    public isEditTeam: boolean = false;
    public isCRMAdmin: boolean = false;

    // Customer Teams edit
    public customerTeamTypeList: CustomerTeamType[] = [];
    public isUpdateTeams: boolean = false;
    public isSelectAllCustomers: boolean = false;
    public customerTeamTypeID: number = 0;
    public selectedFromEmployeeID: number = 0;
    public selectedToEmployeeID: number = 0;
    public parentCodeFilter: string = "";
    public customerCodeFilter: string = "";
    public customerCountryFilter: string = "";
    public selectedCustomers: number[] = [];
    public defaultTeamType: { customerTeamTypeID: number, description: string } = { customerTeamTypeID: 0, description: "Select Type" };
    public defaultEmployee: { employeeId: number, fullName: string } = { employeeId: 0, fullName: "Select Employee" };

    public selectedCity: City[] = [];
    public selectedDistance: number = 25;
    public selectedInitiativeId: any = '';
    public customerStatusIDList: number[] = [];
    public cityControl = new UntypedFormControl();
    public distanceControl = new UntypedFormControl();
    public initiativeControl = new UntypedFormControl();

    public tagTypeList: SearchTagType[] = [];
    public selectedTagTypes: SearchTagType[] = [];
    public isTagListFocus: boolean = false;

    //public salesRepPlaceholder: Employee | undefined;
    //public opsRepPlaceholder: Employee | undefined;
    //public accountRepPlaceholder: Employee | undefined;
    //public customerParentPlaceholder: Customer | undefined;

    //private repType: string = '';
    //private employeeId: number = 0;
    //private filter: string = '';

    private isLockEnabled: boolean = false;
    private recordTypes: RecordType[] = [];
    private searchRecordLock: SearchRecordLock = {} as SearchRecordLock;
    //private isLocked: boolean = false;

    customerListGroup: UntypedFormGroup = new UntypedFormGroup({
        cityControl: new UntypedFormControl(''),
        distanceControl: new UntypedFormControl(''),
        initiativeControl: new UntypedFormControl('')
    });

    public formGroup: UntypedFormGroup = new UntypedFormGroup({
        customerCtrl: new UntypedFormControl('')
    });

    constructor(@Inject('BASE_URL') private baseUrl: string,
        private crmService: CRMService, private employeeService: EmployeeService, private orderService: OrderService,
        private notificationService: NotificationService, private recordLockService: RecordLockService,
        public utilService: UtilService,
        private titleService: Title, private route: ActivatedRoute, private router: Router, private ngZone: NgZone) {
        this.titleService.setTitle('Customer List');
    }

    ngOnInit() {
        this.route.params.subscribe(params => {
            this.repType = params.repType;
            this.employeeID = params.employeeId;
            this.selectedFromEmployeeID = this.employeeID;
            this.filter = params.filter;
            var currentRoute = this.router.url.split('/')[2];
            if (currentRoute == "crm-leads") {
                this.pageType = "Leads"
            }
            else if (currentRoute == "crm-prospects") {
                this.pageType = "Prospects"
            }
            else {
                // Accounts
                this.pageType = "Accounts"
            }
            //console.log("ngOnInit", params, this.route);

            this.selectedCustomers = [];

            this.isCRMAdmin = this.getIsCRMAdmin();
            this.getEmployees();
            this.getRecordTypes();
            this.getCustomerTeamTypes();
            this.getInitiatives();
            this.getTagTypeList();
            this.getCustomerStatuses();
            //this.getCustomerList(true);
        });

        //this.isCRMAdmin = this.getIsCRMAdmin();
        //this.getEmployees();
        //this.getCustomerTeamTypes();
        //this.getInitiatives();

    }

    ngOnChanges() {
        if (this.pageType == "Leads") {
            this.pageTitle = "Unassigned Leads";
        }
        else if (this.pageType == "Prospects") {
            this.pageTitle = "Prospects";
        }
        else {
            this.pageTitle = "Accounts";
        }

        this.selectedFromEmployeeID = this.employeeID;
        this.selectedCustomers = [];
        //console.log("ngOnInit", params);
        //this.getCustomerList(true);
    }

    private getEmployees() {
        this.employeeService.getEmployeesByGroupName('crm user').subscribe(result => {
            this.employeeList = result;
        });
        this.employeeService.getEmployeesByGroupName('Sales').subscribe(result => {
            this.salesReps = result;
            //this.salesRepPlaceholder = result.filter(e => e.firstName == 'UNKNOWN')[0];
        });

        this.employeeService.getEmployeesByGroupName('Ops Rep').subscribe(result => {
            this.opsReps = result;
            //this.opsRepPlaceholder = result.filter(e => e.firstName == 'UNKNOWN')[0];
        });

        this.employeeService.getEmployeesByGroupName('Account Managers').subscribe(result => {
            this.accountReps = result;
            //this.accountRepPlaceholder = result.filter(e => e.firstName == 'UNKNOWN')[0];
        });
    }

    private getCustomerTeamTypes() {
        this.crmService.getCustomerTeamTypes().subscribe(result => {
            this.customerTeamTypeList = result.resultCollection;
            this.customerTeamTypeList = this.customerTeamTypeList.filter(t => t.abbreviation == "AM"
                || t.abbreviation == "Ops Rep"
                || t.abbreviation == "Sales Rep");
        });
    }

    private getInitiatives() {
        //var initiative = {
        //    title: "-- ADD NEW --",
        //    customerInitiativeID: -1,
        //    description: ""
        //} as CustomerInitiative;
        this.crmService.getCustomerInitiatives().subscribe(result => {
            this.initiatives = result;
            //this.initiatives.unshift(initiative);
        });
    }

    private getTagTypeList() {
        this.orderService.getSearchTagTypes().subscribe(result => {
            var lst: SearchTagType[] = result.resultCollection;
            //var orderTagTypes = lst.filter(t => t.recordTypeName == "QuoteOrder");
            //var loadTagTypes = lst.filter(t => t.recordTypeName == "QuoteOrderLine");
            var customerTagTypes = lst.filter(t => t.recordTypeName == "Customer");

            //orderTagTypes = orderTagTypes.sort((left, right): number => {
            //    if (left.tagTypeName < right.tagTypeName) return -1;
            //    if (left.tagTypeName > right.tagTypeName) return 1;
            //    return 0;
            //});

            //loadTagTypes = loadTagTypes.sort((left, right): number => {
            //    if (left.tagTypeName < right.tagTypeName) return -1;
            //    if (left.tagTypeName > right.tagTypeName) return 1;
            //    return 0;
            //});

            customerTagTypes = customerTagTypes.sort((left, right): number => {
                if (left.tagTypeName < right.tagTypeName) return -1;
                if (left.tagTypeName > right.tagTypeName) return 1;
                return 0;
            });

            //this.tagTypeList = [...orderTagTypes, ...loadTagTypes, ...customerTagTypes];
            this.tagTypeList = customerTagTypes;
            //console.log("ngOnInit", lst, orderTagTypes, loadTagTypes, customerTagTypes, this.tagTypeList);
        });
    }

    public toggleTagType(tagType: SearchTagType) {
        var idx: number = this.selectedTagTypes.findIndex(t => t.tagTypeID == tagType.tagTypeID);
        if (idx >= 0) {
            this.selectedTagTypes.splice(idx, 1);
        }
        else {
            this.selectedTagTypes.push(tagType);
        }
        this.filterCustomers();
        console.log("toggleTagType", tagType, this.selectedTagTypes);
    }

    public getTagTypes(idList: string) {
        var tagTypes: SearchTagType[] = [];
        if (idList && idList != "") {
            var arr: number[] = [];
            arr = idList.replace(/, +/g, ",").split(",").map(Number);
            for (var i = 0; i < arr.length; i++) {
                var idx: number = this.tagTypeList.findIndex(t => t.tagTypeID == arr[i]);
                if (idx >= 0) {
                    tagTypes.push(this.tagTypeList[idx]);
                }
            }
        }
        return tagTypes;
    }

    public checkSelectedTagType(tagType: SearchTagType) {
        var idx: number = this.selectedTagTypes.findIndex(t => t.tagTypeID == tagType.tagTypeID);
        //console.log("checkSelectedTagType", idx);
        if (idx >= 0) {
            return "text-primary";
        }
        else {
            return "";
        }
    }

    private getCustomerStatuses() {
        this.crmService.getCustomerStatuses().subscribe(result => {
            // Prepoluate with all but Lead, SW Lead, Disqualified
            this.customerStatusList = result;
            this.customerStatusList = this.customerStatusList.filter(t => t.retiredInd != true);
            this.customerStatusList = this.customerStatusList.sort((left, right): number => {
                if (left.stage < right.stage) return -1;
                if (left.stage > right.stage) return 1;
                return 0;
            });
            this.setCustomerStatusDefault();
            this.searchCustomers();
        });
    }

    private setCustomerStatusDefault() {
        this.customerStatusIDList = [];
        var list: CustomerStatus[] = Object.assign([], this.customerStatusList);
        if (this.filter > 0) {
            list = list.filter(t => t.customerStatusId == this.filter);
        }
        else if (this.pageType == "Leads") {
            //list = list.filter(t => t.abbreviation == "SW Lead" || t.abbreviation == "Lead");
            list = list.filter(t => t.statusType == "Lead");
        }
        else if (this.pageType == "Prospects") {
            //list = list.filter(t => t.abbreviation == "Prospect" || t.abbreviation == "Qualified");
            list = list.filter(t => t.statusType == "Prospect" && t.abbreviation != "Disqualified");
        }
        else {
            //list = list.filter(t => t.abbreviation != "SW Lead" && t.abbreviation != "Lead" && t.abbreviation != "Disqualified");
            list = list.filter(t => t.statusType != "Lead" && t.abbreviation != "Disqualified");
        }
        for (var i = 0; i < list.length; i++) {
            this.customerStatusIDList.push(list[i].customerStatusId);
        }
    }

    private getIsCRMAdmin() {
        var roles: string = "CRM Admin";
        var userHasRole = false;
        var splitRoles = roles.split(',');
        var employeeRoles = localStorage.getItem('EmployeeRoles');

        for (var i = 0; i < splitRoles.length; i++) {
            if (employeeRoles != null && employeeRoles!.indexOf(splitRoles[i].trim()) > -1) {
                userHasRole = true;
            }
        }
        return userHasRole;
    }

    public onTabSelect(evt: any) {
        //console.log("onTabSelect", evt, this.customer, this.searchRecordLock);
        if (evt.title != "Profile") {
            if (this.searchCustomer.customerID > 0) {
                if (this.isLockEnabled) {
                    this.getSearchRecordLock(true);
                }
            }
        }
    }

    //public removeParent() {
    //    this.parentCustomer = {} as Customer;
    //    this.parentCustomerID = 0;
    //    this.customer.parentCustomerId = 0;
    //}

    public searchCustomers() {
        this.getCustomerList(true);
        //console.log("searchCustomers", this.customerStatusIDList);
    }

    public resetFilters() {
        this.customerStatusIDList = [];
        this.setCustomerStatusDefault();
    }

    private getCustomerList(isRefresh: boolean) {
        this.isAdd = false;
        this.utilService.isLoading = true;

        //if (this.pageType == "leads") {
        //    if (isRefresh) {
        //        this.crmService.getSearchCustomerLeads().subscribe(result => {
        //            this.utilService.isLoading = false;
        //            this.customersBase = result.resultCollection;
        //            this.filterCustomers();
        //        });
        //    }
        //    else {
        //        this.utilService.isLoading = false;
        //        this.filterCustomers();
        //    }
        //}
        //else if (this.pageType == "prospects") {
        //}
        //else {
        //    // default to accounts
        //}

        if (isRefresh) {
            var criteria: SearchCustomerCriteria = {
                repType: this.repType,
                employeeID: this.employeeID,
                customerStatusIDList: this.customerStatusIDList,
                cityID: 0,
                miles: 0,
                customerInitiativeID: 0
            }
            this.crmService.getSearchCustomerByCriteria(criteria).subscribe(result => {
                this.utilService.isLoading = false;
                this.customersBase = result.resultCollection;
                this.filterCustomers();
            });
            //if (!this.repType || this.repType == '' || this.employeeID == null || this.employeeID < 1) {
            //    this.crmService.getSearchCustomer().subscribe(result => {
            //        this.utilService.isLoading = false;
            //        this.customersBase = result.resultCollection;
            //        this.filterCustomers();
            //    });
            //} else {
            //    this.crmService.getSearchCustomerByCriteria(this.repType, this.employeeID).subscribe(result => {
            //        this.utilService.isLoading = false;
            //        this.customersBase = result.resultCollection;
            //        this.filterCustomers();
            //    });
            //}
        }
        else {
            this.utilService.isLoading = false;
            this.filterCustomers();
        }

        //console.log("customer-lits:getCustomerList", this.crmService.accounts.length, isRefresh, this.repType, this.employeeID);

        //if (this.crmService.accounts.length > 1) {
        //    if (isRefresh) {
        //        this.crmService.getSearchCustomer().subscribe(result => {
        //            this.utilService.isLoading = false;
        //            this.customersBase = result.resultCollection;
        //            this.crmService.accounts = Object.assign([], this.customersBase);
        //            this.filterCustomers();
        //        });
        //    }
        //    else {
        //        this.utilService.isLoading = false;
        //        this.customersBase = this.crmService.accounts;
        //        this.filterCustomers();
        //    }
        //} else {
        //    if (!this.repType || this.repType == '' || this.employeeID == null || this.employeeID < 1) {
        //        this.crmService.getSearchCustomer().subscribe(result => {
        //            this.utilService.isLoading = false;
        //            this.customersBase = result.resultCollection;
        //            this.filterCustomers();
        //        });
        //    } else {
        //        this.crmService.getSearchCustomerByRepTypeEmployeeID(this.repType, this.employeeID).subscribe(result => {
        //            this.utilService.isLoading = false;
        //            this.customersBase = result.resultCollection;
        //            this.filterCustomers();
        //        });
        //    }
        //}

    }

    private filterCustomers() {
        this.selectedCustomers = [];
        this.customers = Object.assign([], this.customersBase);

        if (this.pageType == "Leads") {
            this.customers = this.customers.filter(t => t.customerStatusType == "Lead");
        }
        else if (this.pageType == "Prospects") {
            this.customers = this.customers.filter(t => t.customerStatusType == "Prospect");
        }

        if (this.isUpdateTeams) {
            if (this.parentCodeFilter != "") {
                this.customers = this.customers.filter(t => t.parentCustomerCode.toLocaleLowerCase().startsWith(this.parentCodeFilter.toLocaleLowerCase()));
            }
            if (this.customerCodeFilter != "") {
                this.customers = this.customers.filter(t => t.customerCode.toLocaleLowerCase().startsWith(this.customerCodeFilter.toLocaleLowerCase()));
            }
            //if (this.customerCountryFilter != "") {
            //    this.customers = this.customers.filter(t => t.cou.toLocaleLowerCase().startsWith(this.parentCodeFilter.toLocaleLowerCase()));
            //}
            var teamType = this.customerTeamTypeList.find(t => t.customerTeamTypeID == this.customerTeamTypeID);
            if (teamType != null && this.selectedFromEmployeeID != 0 && this.selectedFromEmployeeID != -100) {
                //AM
                //Ops Rep
                //Sales Rep
                //Log Spec
                //In Sales
                //ES
                switch (teamType.abbreviation) {
                    case 'AM':
                        this.customers = this.customers.filter(c => c.accountRepID == this.selectedFromEmployeeID);
                        break;
                    case 'Ops Rep':
                        this.customers = this.customers.filter(c => c.opsRepID == this.selectedFromEmployeeID);
                        break;
                    case 'Sales Rep':
                        this.customers = this.customers.filter(c => c.salesEmployeeID == this.selectedFromEmployeeID);
                        break;
                    //case 'Log Spec':
                    //    this.customers = this.customers.filter(c => c.salesEmployeeId == this.selectedFromEmployeeID);
                    //    break;
                    default:
                        this.customers = this.customers;
                        break;
                }
                //console.log("filterCustomers", this.customerTeamTypeID, teamType.abbreviation, this.selectedFromEmployeeID);
            }
            //else {
            //    this.customers = Object.assign([], this.customersBase);
            //}
        }
        else {
            //switch (this.filter) {
            //    case 'untouched':
            //        this.customers = this.customers.filter(c => c.noActionsInd == true);
            //        break;
            //    case 'assigned':
            //        this.customers = this.customers.filter(c => c.accountRepID == this.employeeID || c.salesEmployeeID == this.employeeID || c.opsRepID == this.employeeID);
            //        break;
            //    case 'late':
            //        this.customers = this.customers.filter(c => c.lateSpiderWebLead == true);
            //        break;
            //    default:
            //        this.customers = this.customers;
            //        break;
            //}
            if (this.filter > 0) {
                this.customers = this.customers.filter(t => t.customerStatusID == this.filter);
            }
        }

        //console.log("filterCustomers", this.filter, this.pageType, this.selectedCity, this.customers);

        // Filter by GPS distance
        //this.selectedCity
        //this.selectedDistance
        //this.selectedInitiativeId
        var lat = 0;
        var lon = 0;
        var dist = 0;
        //if (this.selectedFromEmployeeID > 0) {
        //    this.customers = this.customers.filter(t => t.accountRepId == this.selectedFromEmployeeID || t.salesEmployeeId == this.selectedFromEmployeeID || t.opsRepId == this.selectedFromEmployeeID);
        //}

        if (this.selectedCity.length > 0) {
            this.customers = this.customers.filter(c => c.latitude != null && c.longitude != null);
            for (var i = this.customers.length - 1; i >= 0; i--) {
                dist = this.getGPSDistance("mi", this.customers[i].latitude, this.customers[i].longitude, this.selectedCity[0].latitude, this.selectedCity[0].longitude);
                if (dist > this.selectedDistance) {
                    this.customers.splice(i, 1);
                }
            }
            //this.customers = this.customers.filter(c => this.getGPSDistance("mi", c.latitude, c.longitude, this.selectedCity[0].latitude, this.selectedCity[0].longitude) < this.selectedDistance);
        }

        this.filterByTagTypes();

        this.setCustomerGrid();
    }

    private filterByTagTypes() {
        for (var i = 0; i < this.selectedTagTypes.length; i++) {
            this.customers = this.customers.filter(o =>
                o.tagTypes != ""
                && (
                    o.tagTypes == this.selectedTagTypes[i].tagTypeID.toString()
                    || o.tagTypes.startsWith(this.selectedTagTypes[i].tagTypeID + ",")
                    || o.tagTypes.includes("," + this.selectedTagTypes[i].tagTypeID + ",")
                    || o.tagTypes.endsWith("," + this.selectedTagTypes[i].tagTypeID)
                )
            );
        }
        //console.log("filterByTagTypes", this.selectedTagTypes, this.quoteOrderLinesPlanned);
    }

    public checkEmptyCity(event: any) {
        if (!this.customerListGroup.controls['cityControl'].value) {
            this.selectedCity.length = 0;
            this.filterCustomers();
        }
    }

    public getGPSDistance(units: string, lat1?: number, lon1?: number, lat2?: number, lon2?: number) {
        if (lat1 == null || lon1 == null || lat2 == null || lon2 == null) {
            return this.selectedDistance + 1;
        }

        var dist: number = 0;
        var factor: number = 3963.1906; // 6378137m * 100cm / 2.54in / 12ft / 5280mi
        var degToRad: number = 180 / Math.PI;
        var unitConv: number = 1; // default miles
        var a: number = lat1 / degToRad;
        var b: number = lon1 / degToRad;
        var c: number = lat2 / degToRad;
        var d: number = lon2 / degToRad;

        if (units == "ft" || units == "feet") {
            unitConv = 5280;
        }

        if (a == c && b == d) {
            dist = 0;
        }
        else {
            dist = Math.sin(a) * Math.sin(c) + Math.cos(a) * Math.cos(c) * Math.cos(b - d);
            if (dist > 1) {
                dist = 1;
            }
            else {
                dist = factor * Math.acos(dist);
            }
        }

        return dist;
    }

    public dataStateChange(state: DataStateChangeEvent): void {
        this.gridState = state;
        this.setCustomerGrid();
    }

    public filterCustomersForTeamUpdate() {
        this.filterCustomers();
        this.customers = this.customers.filter(t => t.activeInd == true && t.retiredInd != true);
        this.setCustomerGrid();
    }

    public toggleCustomer(customerID: number) {
        var idx: number = -1;
        if (customerID > 0) {
            idx = this.selectedCustomers.findIndex(t => t == customerID);
            if (idx >= 0) {
                this.isSelectAllCustomers = false;
                this.selectedCustomers.splice(idx, 1);
            }
            else {
                this.selectedCustomers.push(customerID);
            }
        }
        else {
            //this.isSelectAllCustomers = true;
            this.isSelectAllCustomers = !this.isSelectAllCustomers;
            this.selectedCustomers = [];
            if (this.isSelectAllCustomers) {
                if (this.customers.length <= 500) {
                    this.customers.forEach(t => {
                        this.selectedCustomers.push(t.customerID);
                    });
                }
                else {
                    this.isSelectAllCustomers = false;
                    this.notificationService.showError("Please filter to less than 500 records before you Select All.", "ERROR: Selet All");
                }
            }
        }
        //console.log("toggleWonChecked", idx, quoteOrderID, this.isSelectAllLanes, this.selectedLanes);
    }

    public isCustomerSelected(customerID: number) {
        var isSelected: boolean = false;
        if (customerID > 0) {
            var idx = this.selectedCustomers.findIndex(t => t == customerID);
            if (idx >= 0) {
                isSelected = true;
            }
        }
        //console.log("isLaneSelected", quoteOrderID, isSelected, this.isSelectAllLanes, this.selectedLanes);
        return isSelected;
    }

    public saveCustomerTeams() {
        //console.log("saveCustomerTeams", this.customerTeamTypeID, this.selectedFromEmployeeID, this.selectedToEmployeeID, this.selectedCustomers);
        this.utilService.isLoading = true;
        var lastModifiedByEmployeeID = localStorage.getItem('EmployeeId') == null ? -1 : parseInt(localStorage.getItem('EmployeeId')!);
        this.crmService.saveCustomerTeamMapList(this.selectedCustomers, this.customerTeamTypeID, this.selectedToEmployeeID, lastModifiedByEmployeeID).subscribe(result => {
            this.utilService.isLoading = false;
            //console.log("saveCustomerTeamMapList", this.selectedCustomers, this.customerTeamTypeID, this.selectedToEmployeeID, result);
            this.cancel();
            this.getCustomerList(true);
        });
    }

    public addNew() {
        this.isAdd = true;
    }

    public cancelEdit() {
        this.isAdd = false;
        this.isEdit = false;
        this.isEditTeam = false;
        this.customerListGrid.filterable = true;
        this.getCustomerList(false);
    }

    public edit(customerID: number) {
        this.isEdit = true;
        var cust = this.customers.find(t => t.customerID == customerID);
        if (cust != null) {
            this.searchCustomer = cust;
        }
        else {
            this.searchCustomer = {} as SearchCustomer;
        }
        if (this.isLockEnabled) {
            this.getSearchRecordLock(false);
        }
        //this.crmService.getCustomerById(customerID).subscribe(result => {
        //    this.customer = result;
        //    if (this.isLockEnabled) {
        //        this.getSearchRecordLock(false);
        //    }
        //    this.getCustomer(this.customer.parentCustomerId, "customer", false);
        //});
    }

    public editTeam(customerID: number) {
        this.isEditTeam = true;
        this.customerListGrid.filterable = false;
        this.customerID = customerID;
        this.setCustomerGrid();
    }

    public customerTeamRefresh() {
        this.isEditTeam = false;
        this.customerListGrid.filterable = true;
        this.customerID = 0;
        this.getCustomerList(true);
    }

    public customerAddSaved(evt: any) {
        this.isAdd = false;
        if (evt != "" && evt != null) {
            this.customerID = evt;
            this.edit(this.customerID);
        }
    }

    public customerEditRefresh(evt: any) {
        //console.log("customerEditRefresh", evt, this.isEdit, this.customer, this.customerID);
        this.isEdit = false;
        if (this.searchCustomer.customerID > 0 && !isNaN(evt) && evt != null) {
            if (this.isLockEnabled) {
                this.clearRecordLock();
            }
        }
        this.searchCustomer = {} as SearchCustomer;
        this.customerID = 0;
        //this.parentCustomer = {} as Customer;
        this.parentCustomerID = 0;
        if (evt != undefined) {
            this.getCustomerList(true);
        }
        else {
            this.getCustomerList(false);
        }
        //console.log("customerEditRefresh", evt);
    }

    public cancel() {
        this.searchCustomer = {} as SearchCustomer;
        //this.editedCustomer = {} as Customer;
        this.isEdit = false;
        this.isUpdateTeams = false;
        this.isSelectAllCustomers = false;
        this.customerTeamTypeID = 0;
        this.selectedFromEmployeeID = 0;
        this.selectedToEmployeeID = 0;
        this.selectedCustomers = [];
        this.customers = Object.assign([], this.customersBase);
    }

    //private getCustomer(customerID: number, customerType: string, isChange: boolean) {
    //    this.crmService.getCustomerById(customerID).subscribe(result => {
    //        var cust: Customer = result;
    //        if (customerType == "customer") {
    //            //this.parentCustomer = Object.assign({}, cust);
    //            if (isChange) {
    //                this.searchCustomer.parentCustomerID = this.parentCustomerID;
    //            }
    //        }
    //        //console.log("getCustomer", customerID, this.parentCustomerID, this.parentCustomer);
    //    });
    //}

    //public customerEditHandler({ sender, rowIndex, dataItem }) {
    //    this.customerCloseEditor(sender);

    //    this.editedCustomerRowIndex = rowIndex;
    //    this.editedCustomer = Object.assign({}, dataItem);

    //    sender.editRow(rowIndex);
    //}

    //public customerCancelHandler({ sender, rowIndex }) {
    //    this.customerCloseEditor(sender, rowIndex);
    //    this.customerIsValid = true;
    //}

    //private customerCloseEditor(grid, rowIndex = this.editedCustomerRowIndex) {
    //    grid.closeRow(rowIndex);
    //    this.resetCustomer(this.editedCustomer);
    //    this.editedCustomerRowIndex = undefined;
    //    this.editedCustomer = {} as Customer;
    //}

    private resetCustomer(cust: Customer) {
        if (!cust) return;

        const originalCustomer = this.customers.find(s => s.customerID == cust.customerID)!;

        Object.assign(originalCustomer, stop);
    }

    private setCustomerGrid() {
        if (this.gridState.sort) {
            this.customers = orderBy(this.customers, this.gridState.sort);
        }
        //console.log("state", this.gridState, "customers[1000]", this.customers[1000]);
        //this.selectedCustomers = [];
        this.gridData = process(this.customers, this.gridState);
        //console.log("setCustomerGrid", this.selectedCustomers, this.gridData.data[0]);
        this.fitColumns();
    }

    private fitColumns() {
        this.ngZone.onStable.asObservable().pipe(take(1)).subscribe(() => {
            if (this.customerListGrid == null) return;
            this.customerListGrid.autoFitColumns();
        });
    }

    public repSet(customer: SearchCustomer) {
        //this.crmService.setFirstRepOnCustomer(customer).subscribe(result => {
        //    if (result != null && result.customerId > 0) {
        //        alert('Successfully set rep on ' + result.name);
        //    }
        //});
        return;
    }

    public parentSet(customer: SearchCustomer) {
        //if (customer.parentCustomerID == -99) {
        //    customer.parentCustomerID = 0;
        //}
        //this.crmService.saveCustomerFromList(customer).subscribe(result => {
        //    if (result != null && result.customerId > 0) {
        //        alert('Saved');
        //    }            
        //}, error => {
        //    alert('Error saving customer');
        //});
        return;
    }

    public search() {
        this.filtersChanged(null, "");
        this.filterCustomersForTeamUpdate();
    }

    //public filtersChanged(customerInitiative: CustomerInitiative) {
    public filtersChanged(event: any, filterType: string) {
        var customerInitiative;
        var dist;

        //console.log("filtersChanged", event, filterType);

        //console.log(this.customersBase[0]);
        if (filterType == "initiative") {
            customerInitiative = event as CustomerInitiative;
            if (customerInitiative && customerInitiative.customerInitiativeID == -1) {
                this.addNewInitiative();
                return;
            }
            //console.log("filterType", filterType, "customerInitiative", customerInitiative);
        }
        else {
            customerInitiative = this.customerListGroup.controls['initiativeControl'].value as CustomerInitiative;
            //console.log("filterType", filterType, "customerInitiative", customerInitiative);
        }

        this.selectedCity.length = 0;
        if (filterType == "city") {
            this.selectedCity.push(event.option.value as City);
        }
        else if (this.customerListGroup.controls['cityControl'].value) {
            this.selectedCity.push(this.customerListGroup.controls['cityControl'].value as City);
        }

        var dist = this.customerListGroup.controls['distanceControl'].value;
        if (this.selectedCity.length > 0 && (dist == "" || dist == null || dist == 0)) {
            this.customerListGroup.controls['distanceControl'].setValue(25);
        }
        this.selectedDistance = this.customerListGroup.controls['distanceControl'].value;

        this.filterCustomers();

        //console.log("filtersChanged", event, filterType, this.customerTeamTypeID);

        //console.log("customerInitiative", customerInitiative);
        if (customerInitiative == undefined) {
            if (this.gridState.filter != null) {
                this.gridState.filter.filters.forEach(f => {
                    if (f['field'] == 'initiatives') {
                        f['value'] = '';
                    }
                });
            }

            this.setCustomerGrid();
            return;
        }

        var initiative = this.initiatives.find(i => i.customerInitiativeID == customerInitiative.customerInitiativeID);

        //console.log("initiative", initiative);
        if (initiative == undefined) return;

        if (this.gridState.filter == null) {
            this.gridState.filter = { filters: [{ field: 'initiatives', operator: 'contains', value: initiative.title }], logic: 'and' } as CompositeFilterDescriptor;
        } else {
            var initiativeExists = false;
            this.gridState.filter.filters.forEach(f => {
                if (f['field'] == 'initiatives') {
                    initiativeExists = true;
                    f['value'] = initiative!.title;
                }
            });

            if (!initiativeExists) {
                this.gridState.filter.filters.push({ field: 'initiatives', operator: 'contains', value: initiative.title });
            }
        }

        this.filterByTagTypes();

        this.setCustomerGrid();
    }

    public filterFromToEmployees() {
        if (this.customerTeamTypeID > 0) {
            var teamType: CustomerTeamType = this.customerTeamTypeList.find(t => t.customerTeamTypeID == this.customerTeamTypeID)!;
            if (teamType.abbreviation == "AM") {
                this.fromEmployeeList = Object.assign([], this.accountReps);
                this.toEmployeeList = Object.assign([], this.accountReps);
            }
            else if (teamType.abbreviation == "Ops Rep") {
                this.fromEmployeeList = Object.assign([], this.opsReps);
                this.toEmployeeList = Object.assign([], this.opsReps);
            }
            else if (teamType.abbreviation == "Sales Rep") {
                this.fromEmployeeList = Object.assign([], this.salesReps);
                this.toEmployeeList = Object.assign([], this.salesReps);
            }
            else {
                this.fromEmployeeList = [];
                this.toEmployeeList = [];
            }
            var anyEmployee: Employee = {} as Employee;
            anyEmployee.fullName = "-- ANY --"
            anyEmployee.employeeId = -100;
            this.fromEmployeeList.unshift(anyEmployee);
        }
        //console.log("filterFromToEmployees", this.customerTeamTypeID);
    }

    public addNewInitiative() {
        if (typeof this.customerListGroup.controls.initiativeControl.value !== 'string' || this.customerListGroup.controls.initiativeControl.value.toString() == '') return;

        var newInitiative = { title: this.customerListGroup.controls.initiativeControl.value, description: this.customerListGroup.controls.initiativeControl.value } as CustomerInitiative;
        this.crmService.saveCustomerInitiative(newInitiative).subscribe(result => {
            this.initiatives.push(result);
            this.selectedInitiativeId = result.customerInitiativeID;
        });
    }

    private getRecordTypes() {
        this.recordLockService.getRecordTypes().subscribe(result => {
            this.recordTypes = result.resultCollection;
        });
    }

    private clearRecordLock() {
        var recordTypeID = this.recordTypes.find(r => r.recordTypeName == "Customer")!.recordTypeID;
        var employeeID = parseInt(localStorage.getItem('EmployeeId')!);
        var recordID = this.searchCustomer.customerID;

        //console.log("clearRecordLock", this.searchRecordLock, recordTypeID, employeeID, recordID);
        if (this.searchRecordLock.lockSource && this.searchRecordLock.lockSource == "Customer List: Edit Customer") {
            // Clear all locks for this employee before handling the current record
            this.recordLockService.clearRecordLockByRecordTypeEmployeeRecord(recordTypeID, employeeID, recordID).subscribe(result => {
                var col = result.resultCollection;
                //this.isLocked = false;
            });
            //this.recordLockService.clearRecordLock("QuoteOrder", recordID, this.recordLockSource);
        }
    }

    private getSearchRecordLock(isClearAfter: boolean) {
        this.recordLockService.getSearchRecordLockByRecordTypeNameRecordID("Customer", this.searchCustomer.customerID).subscribe(result => {
            //var canLock = false;
            if (result.resultCollection.length > 0) {
                var searchCol: SearchRecordLock[] = Object.assign([], result.resultCollection);
                searchCol = searchCol.filter(t => t.releasedByEmployeeID == null);
                this.searchRecordLock = searchCol[0];
                //console.log("getSearchRecordLock:searchRecordLock", this.searchRecordLock, result);
                if (isClearAfter) {
                    this.clearRecordLock();
                }
            }
            else {
                this.searchRecordLock = {} as SearchRecordLock;
            }
        });
    }
}
